import React, { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import AudioLoading from 'images/audio-loading.svg?react';

export const ConnectingAudio: FunctionComponent = () => {
  return (
    <div className={styles['connecting-audio']}>
      <AudioLoading />
      <strong>Connecting audio</strong>
    </div>
  );
};
